import React, {useState} from 'react';

import styled from 'styled-components';
import theme from '../../../../styles/theme';

import { useGetItemHistSel } from '../../../../interface/item';

import moment from 'moment';

import { useEffect } from 'react';

import CommonDataGrid from '../../../common/CommonDataGrid';
import { NumericFormat } from 'react-number-format';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    height: 90vh;
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;
const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}
const histColumns = [
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_nm', headerName: '모델명', width:300 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'rid', headerName: '연계자산', width:100 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1', headerName: '책임자', width:100 },
    { field: 'uid2', headerName: ' 부책임자', width:100 },
    { field: 's_out_cnt', headerName: '조사반출', width:120 },
    { field: 's_in_cnt', headerName: '조사반입', width:120 },
    { field: 's_use_cnt30', headerName: '최근30일사용횟수', width:120 },
    { field: 's_use_cnt60', headerName: '최근60일사용횟수', width:120 },
    { field: 'f_out_cnt', headerName: '수리반출', width:120 },
    { field: 'f_in_cnt', headerName: '수리반입', width:120 },
    { field: 'f_use_cnt30', headerName: '최근30일수리횟수', width:120 },
    { field: 'f_use_cnt60', headerName: '최근60일수리횟수', width:120 },
    { field: 'r_out_cnt', headerName: '임대반출', width:120 },
    { field: 'r_in_cnt', headerName: '임대반입', width:120 },
    { field: 'r_use_cnt30', headerName: '최근30일임대횟수', width:120 },
    { field: 'r_use_cnt60', headerName: '최근60일임대횟수', width:120 },
    { field: 'l_out_cnt', headerName: '판매반출', width:120 },
    { field: 'l_in_cnt', headerName: '판매반입', width:120 },
    { field: 'l_use_cnt30', headerName: '최근30일판매횟수', width:120 },
    { field: 'l_use_cnt60', headerName: '최근60일판매횟수', width:120 },
    { field: 'z_out_cnt', headerName: '기타반출', width:120 },
    { field: 'z_in_cnt', headerName: '기타반입', width:120 },
    { field: 'z_use_cnt30', headerName: '최근30일기타횟수', width:120 },
    { field: 'z_use_cnt60', headerName: '최근60일기타횟수', width:120 },
]

const Hist = () => {

    const [histList, setHistList] = useState([]);

    const {data : itemHist, isLoading, refetch: histRefetch} = useGetItemHistSel({});

    useEffect(()=>{
        if(itemHist){
            setHistList(itemHist.map((item,index)=>({
                ...item,
                id:index,
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                ));
        }else{
            setHistList([])
        }
    },[itemHist])

    return (
        <MainWrap>
            <CommonDataGrid
                isLoading={isLoading}
                list={histList}
                columns={histColumns}
                // onRowClick={(e)=>{setTarget(e.row);setRegOpen(true)}}
                />
        </MainWrap>
    )

}

export default Hist;